import React from "react";
import { CheckFeature } from "../../CheckFeature";
import {
  LICENSE_FEATURE,
  LIFECYCLE_STATUS_GUID,
} from "../../../utils/constants";
import { Flex } from "@fluentui/react-northstar";
import { TicketLifecyclePhaseElement } from "../../TicketLifecycleTab/TicketLifecyclePhaseRibbon";
import AppCSS from "../../../../../../src/components/App.module.css";
import { appState, useSetState } from "../../../../AppState";

type TicketLifecyclePhaseProps = {
  ticketData: any;
  isAnalyst: boolean;
};

export const DisplayLifecycleWithPhasesPrint: React.FC<
  TicketLifecyclePhaseProps
> = ({ ticketData, isAnalyst }) => {
  const currentstate = appState();
  const setAppState = useSetState();

  const isPastPhase = (phase: TicketLifecyclePhase) => {
    if (phase.IsCurrent) {
      return false;
    } else {
      const phases = ticketData["TicketLifecycle"]["Phases"]
        .sort(function (a: TicketLifecyclePhase, b: TicketLifecyclePhase) {
          return a.Order - b.Order;
        })
        .map(function (phase: TicketLifecyclePhase) {
          return phase;
        });
      const currentPhaseOrder = phases.find((x) => x.IsCurrent)?.Order;
      if (phase.Order < currentPhaseOrder) return true;
    }
    return false;
  };
  return (
    <>
      <CheckFeature featureName={LICENSE_FEATURE.TicketLifecycle}>
        <Flex
          vAlign="center"
          gap="gap.small"
          className={`${AppCSS["grid-item"]}`}
        >
          <div className={`w-full`}>
            {ticketData["TicketLifecycle"] && (
              <>
                <Flex
                  className={
                    "cui-pt-4 cui-pv-4 gap-10 lifecycle-steps-container"
                  }
                >
                  {ticketData["TicketLifecycle"]["Phases"]
                    .sort(function (
                      a: TicketLifecyclePhase,
                      b: TicketLifecyclePhase
                    ) {
                      return a.Order - b.Order;
                    })
                    .map((phase: TicketLifecyclePhase) => {
                      return (
                        <div
                          key={phase.Id}
                          className={`${
                            isAnalyst ? "cursor-pointer" : ""
                          } lifecycle-step`}
                          title={phase?.Name ?? ""}
                          onClick={(e) => {
                            if (
                              currentstate.lifecyclePhaseMenu != phase.Order &&
                              isAnalyst
                            )
                              setAppState((prevState) => ({
                                ...prevState,
                                lifecycleMenuOpen: true,
                                lifecyclePhaseMenu: phase.Order,
                              }));
                            e.stopPropagation();
                          }}
                        >
                          <TicketLifecyclePhaseElement
                            id={`phase-ribbon-${phase.Order}`}
                            extraClassNames={"ml-3.5"}
                            status={
                              phase.IsCurrent
                                ? ticketData?.TicketLifecycle?.Status
                                : {
                                    Guid: LIFECYCLE_STATUS_GUID.NOT_STARTED,
                                  }
                            }
                            phaseName={phase?.Name ?? ""}
                            isPastPhase={isPastPhase(phase)}
                          />
                        </div>
                      );
                    })}
                </Flex>
              </>
            )}
          </div>
        </Flex>
      </CheckFeature>
    </>
  );
};
